import mixins from 'vue-typed-mixins'
import { Redemption } from '~models/redemption'
import Utilities from '~mixins/utilities'

export default mixins(Utilities).extend({
  computed: {
    redemption(): Redemption | undefined {
      return this.$store.state.redemptions.redemption
    },
    maxVouchers(): number {
      return this.redemption?.maxVouchersCount || 1
    },
  },
})
